import makeApi from '../client/api'

export const getPropositionInvite = async (inviteId) => {
  const api = makeApi()

  const data = await api.getOne('/propositions/invite', { id: inviteId })
  return { data }
}

export const consumePropositionInvite = async (token, propositionId) => {
  const { api } = makeApi({ token: 'Bearer ' + token })

  const response = await api.get(`/propositions/invite/${propositionId}/consume`)
  return response
}

export const getProposition = async (token, propositionId) => {
  const api = makeApi({ token: 'Bearer ' + token })

  const data = await api.getOne('/propositions', { id: propositionId })
  return { data }
}
